import { render } from "./generalreportflat.vue?vue&type=template&id=c626196c"
import script from "./generalreportflat.vue?vue&type=script&lang=js"
export * from "./generalreportflat.vue?vue&type=script&lang=js"

import "./generalreportflat.vue?vue&type=style&index=0&id=c626196c&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__